import { InlineText1, InlineText2, Tooltip } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';
import * as React from 'react';
import * as styles from './AuctionPointsHint.css';

export const AuctionPointsHint = () => (
  <Tooltip
    theme="black"
    placement="top-end"
    title={
      <div className={styles['content']}>
        <div className={styles['header']}>
          <InlineText1 color="white_100" fontWeight="bold">
            Баллы на продвижение в поиске
          </InlineText1>
        </div>

        <InlineText2 color="white_100">При покупке Топ или Премиум начисляются баллы, 1 балл = 1 рубль</InlineText2>
      </div>
    }
  >
    <Faq16 color="primary_100" cursor="pointer" />
  </Tooltip>
);
